import React from "react";

import { Menu } from "@mui/material";
import Button from "@mui/material/Button";
import { StyledMenuItem } from "src/components/StyledMenuItem/StyledMenuItem";

interface TableActionItem {
  label: string;
  handler: () => void;
}

interface TableActionsProps {
  actions: TableActionItem[];
}

export const TableActions = (props: TableActionsProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event: React.MouseEvent<HTMLLIElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <div className="bootstrap-fix-fonts">
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
          <path
            d="M8.25 12.75C8.25 13.1412 8.58579 13.4583 9 13.4583C9.41421 13.4583 9.75 13.1412 9.75 12.75C9.75 12.3588 9.41421 12.0417 9 12.0417C8.58579 12.0417 8.25 12.3588 8.25 12.75Z"
            stroke="#B4B4C4"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.25 8.5C8.25 8.8912 8.58579 9.20833 9 9.20833C9.41421 9.20833 9.75 8.8912 9.75 8.5C9.75 8.1088 9.41421 7.79167 9 7.79167C8.58579 7.79167 8.25 8.1088 8.25 8.5Z"
            stroke="#B4B4C4"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.25 4.25C8.25 4.6412 8.58579 4.95833 9 4.95833C9.41421 4.95833 9.75 4.6412 9.75 4.25C9.75 3.8588 9.41421 3.54167 9 3.54167C8.58579 3.54167 8.25 3.8588 8.25 4.25Z"
            stroke="#B4B4C4"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}>
        {props.actions.map((action: TableActionItem) => {
          return (
            <StyledMenuItem
              key={action.label}
              onClick={event => {
                handleClose(event);
                action.handler();
              }}>
              {action.label}
            </StyledMenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
